'use client';
/**
 * Выполняет проверку того, что `subject` является `number`.
 *
 * @remarks
 * Type-guard обёртка над `typeof`.
 *
 * @param subject - Субъект проверки произвольного типа.
 *
 * @stable
 * */ const isNumber = (subject)=>typeof subject === 'number';

export { isNumber };
//# sourceMappingURL=isNumber.js.map
